<template>
    <div>
        <nav class="navbar navbar-dark bg-dark justify-content-between flex-nowrap flex-row">
        <div class="container">
            <a class="navbar-brand float-left">
                <img src="https://static.innovorder.fr/dashboard/images/logo-menu-new.png" class="logo">
                Order Display System
            </a>
            <ul class="nav navbar-nav flex-row float-right">
            <li class="nav-item">
                <router-link class="nav-link pr-3" to="/create">Gestion</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link pr-3" to="/config">Configuration</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" to="/list">Affichage en salle</router-link>
            </li>
            </ul>
        </div>
        </nav>
        <div class="container mt-5">
            <div class="row justify-content-center">
                <div class="col-md-5">
                    <h3 class="text-center">Ajouter un ticket</h3>
                    <form @submit.prevent="onFormSubmit">
                        <div class="form-group">
                            <label>Numéro de ticket</label>
                            <input type="text" class="form-control" v-model="ticket.number" required>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-warning btn-block">Ajouter un ticket</button>
                        </div>
                    </form>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-5">
                    <h3 class="text-center">Tickets actuellement affichés</h3>
                    <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Numéro</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ticket in tickets" :key="ticket.key">
                                    <td><h2>{{ ticket.number }}</h2></td>
                                    <td>
                                        <button @click.prevent="deleteTicket(ticket.key)" class="btn-lg btn-warning">Supprimer</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
    import { db } from '../firebaseDb';

    export default {
        data() {
            return {
                tickets: [],
                ticket: {
                },
                restaurantId: 0
            }
        },
        created() {
            this.restaurantId = this.$cookies.get('ods-restaurant-id');
            db.collection('restaurants/'+this.restaurantId+'/tickets').onSnapshot((snapshotChange) => {
                this.tickets = [];
                snapshotChange.forEach((doc) => {
                    this.tickets.push({
                        key: doc.id,
                        number: doc.data().number
                    })
                });
            })
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault()
                db.collection('restaurants/'+this.restaurantId+'/tickets').add(this.ticket).then(() => {
                    this.ticket.number = ''
                }).catch((error) => {
                    alert('Une erreur est survenue ('+JSON.stringify(error)+')');
                });
            },
            deleteTicket(id){
              db.collection('restaurants/'+this.restaurantId+'/tickets').doc(id).delete().then(() => {
                    console.log("Document deleted!");
                })
                .catch((error) => {
                   alert('Une erreur est survenue ('+JSON.stringify(error)+')');
                })
            }
        }
    }
</script>

<style scoped>
    .logo {
        max-width: 135px;
        max-height: 22px;
    }
    .btn-primary {
        margin-right: 12px;
    }
</style>